import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'

import {isLocalProfile} from '@web/core/config'
import {createStore} from '@web/helpers/redux'
import {browserConfirm, browserEventEmitter} from '@web/middlewares/browserEventEmitter'
import {uiEventAction} from '@web/middlewares/uiLogging'

import {AppDispatch, RootState} from '../interfaces'

import {orderInterruptedMiddleware, uiLogTracker, auth} from './middleware'
import createRootReducer from './reducer'

const middlewares = [orderInterruptedMiddleware, uiLogTracker, browserEventEmitter, auth]

const store = createStore<RootState>({
    rootReducerCreator: createRootReducer,
    middlewares: [...middlewares],
    defaultMiddlewareOptions: {
        serializableCheck: {
            ignoredActions: [uiEventAction.type, browserConfirm.type],
        },
    },
})

export default store

export const useDeliveryPageDispatch = () => useDispatch<AppDispatch>()

export const useDeliveryPageSelector: TypedUseSelectorHook<RootState> = useSelector

if (isLocalProfile && module.hot) {
    module.hot.accept('./reducer', () => store.replaceReducer(createRootReducer()))
}
